<template>
  <div>
    <simpletoolbar></simpletoolbar>
    <faq-tabs></faq-tabs>
    <app-footer />
  </div>
</template>

<script setup>
import simpletoolbar from '@components/ui/simpletoolbar.vue';
import faqTabs from '@components/ui/faqTabs.vue';
import appFooter from '@components/ui/appFooter.vue';
import { useSeo } from '@/composables/useSeo';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// Set up SEO metadata for FAQ page
useSeo({
  title: () => `${t('app.Frequently Asked Questions')} | Spin the Names`,
  description: () => t('app.Common questions about using the random name picker wheel'),
  structuredData: () => ([
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': [
        {
          '@type': 'Question',
          'name': t('faq.How do I use this app'),
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': t('faq.This app lets you spin a wheel')
          }
        },
        {
          '@type': 'Question',
          'name': t('faq.Can I save my wheel'),
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': t('faq.Yes, if you create an account')
          }
        },
        {
          '@type': 'Question',
          'name': t('faq.Is this app free'),
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': t('faq.Yes, this app is completely free')
          }
        }
      ]
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': 'https://spinthenames.com/' },
        { '@type': 'ListItem', 'position': 2, 'name': 'FAQ', 'item': 'https://spinthenames.com/faq' }
      ]
    }
  ]),
  ogType: 'article'
});
</script>
